import backend, {WORKFLOW_ENGINE_API} from 'utils/backend/server/api_library';

const getAll = () => {
  const url = `${WORKFLOW_ENGINE_API}/system/get_all`;
  return backend.get(url);
};

export default {
  getAll,
};
